import { REM } from './fontsize';

export const SPACE_BETWEEN_SLIDES = {
  DESKTOP: 1.5 * REM,
  MOBILE: 0.75 * REM
}
